import { render, staticRenderFns } from "./ShowCartButton.vue?vue&type=template&id=6de47566"
import script from "./ShowCartButton.vue?vue&type=script&lang=ts"
export * from "./ShowCartButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de47566')) {
      api.createRecord('6de47566', component.options)
    } else {
      api.reload('6de47566', component.options)
    }
    module.hot.accept("./ShowCartButton.vue?vue&type=template&id=6de47566", function () {
      api.rerender('6de47566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/ShowCartButton.vue"
export default component.exports